import { render, staticRenderFns } from "./SeleccionModoPago.vue?vue&type=template&id=7812ba85"
import script from "./SeleccionModoPago.vue?vue&type=script&lang=js"
export * from "./SeleccionModoPago.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports